<template>
  <BaseTab id="thoughtCatcher">
    <div />
    <v-text-field
      v-model="addThoughtText"
      class="mx-auto add-thought-field"
      label="Add a private thought..."
      hint="Press enter to submit your thought"
      persistent-hint
      @keydown.enter="handleAddThought"
      rounded
      filled
      flat
      solo-inverted
      :disabled="currentlyViewedChallenge.archived"
    />
    <v-divider class="mt-6" />
    <v-subheader class="mt-2">PRIVATE THOUGHTS</v-subheader>
    <div class="ml-4 grey--text">Click on a private thought to make it public or move to the parking lot</div>
    <v-list two-line>
      <template v-for="(thought, i) in privateThoughts">
        <PrivateThought
          :key="'thought-'+i"
          :thought="thought"
        />
      </template>
    </v-list>
    <v-subheader>PUBLIC THOUGHTS</v-subheader>
    <v-list two-line>
      <template v-for="thought in publicThoughts">
        <PublicThought
          :key="thought.uuid"
          :thought="thought"
        />
      </template>
    </v-list>
  </BaseTab>
</template>

<script>
import BaseTab from '@/components/base/BaseTab'
import PrivateThought from './PrivateThought'
import PublicThought from './PublicThought'
import interact from 'interactjs'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ThoughtCatcher',

  components: {
    BaseTab,
    PrivateThought,
    PublicThought
  },

  data: () => ({
    addThoughtText: ''
  }),

  async created () {
    await this.requestAllThoughts()
  },

  methods: {
    ...mapActions('canvas', ['requestCreatePrivateThought', 'requestAllThoughts']),
    handleAddThought () {
      if (this.addThoughtText !== '') {
        // trim leading + trailing whitespace
        const thoughtText = this.addThoughtText.trim()

        this.requestCreatePrivateThought(thoughtText)
        this.requestAllThoughts()
        this.addThoughtText = ''
      }
    }
  },

  computed: {
    ...mapState({
      privateThoughts: state => state.canvas.thoughtCatcher.privateThoughts,
      publicThoughts: state => state.canvas.thoughtCatcher.publicThoughts,
      currentlyViewedChallenge: state => state.challenge.currentlyViewedChallenge
    })
  },

  mounted () {
    interact('#thoughtCatcher').dropzone({})
  }
}
</script>

<style lang="sass" scoped>
  .search-bar
    width: 250px
    top: 1em

  .add-thought-field
    width: 250px
    top: 1em

  .thought
    background-image: linear-gradient(120deg, rgba(255, 149, 24, 0.9), rgba(255,149,24,0.4))
    touch-action: none
    margin: 1em

  .private-thought:hover
    background-image: linear-gradient(120deg, rgba(255, 100, 100, 0.9), rgba(255,149,24,0.4))
    cursor: pointer
</style>
